import { paymentMethodOptions } from '../config/payment-methods.config';
import type { PaymentMethod } from '../model/payment.types';

export function formatPaymentMethod(method: PaymentMethod, checkNumber: string | null): string {
    const label = paymentMethodOptions.find((option) => option.value === method)?.label ?? method;

    return method === 'CHECK' && checkNumber ? `${label} ${checkNumber}` : label;
}
